<template>
  <nav
    class="navbar navbar-expand-lg inner-header d-flex justify-content-between px-3 py-2 "
  >
    <a class="navbar-brand brand-logo">
      <img :src="logo" alt="">
    </a>
    <DemoDisclaimer />
    <div class="modal" id="tokenWarningModal" tabindex="-1" role="dialog" aria-labelledby="tokenWarningModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Session Expiry Warning</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <a>
                    <span class="p-2 modalspan" > Your session is about expire. Please click Ok to continue</span>
                </a>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="next-btn mb-4" @click="tokenExpireWarningCancel = true"  >Cancel</button>
                <button type="button" class="next-btn mb-4" @click="tokenExpireWarning = true"  >Ok</button>
            </div>
            </div>
        </div>
        </div>
        <label class="switch"  v-if="darkModePresent">
            <input type="checkbox" @change="toggleTheme()" :checked="isDarkMode">
            <span class="sliderToggle"></span>
        </label>
  </nav>
</template>

<script>
import $ from "jquery";
import { getDistributer, hasDarkMode } from "@/mixins/common";
import {
  ensureDiyLandAccess,
  establishDiySessionFromRoute,
  getDiyJourneyIdFromRoute,
  getDiyResumeTokenFromRoute,
  hasDiyDeepLinkQuery,
  redirectDiySessionFailure,
  redirectUnauthorizedLegacyJourney,
} from "@/utils/resumeTokenSession";
import { ROLE_ID } from "@/constants/roles";
import { buildRouteUrl } from "@/mixins/util";
import DemoDisclaimer from "../DemoDisclaimer.vue";
export default {
  name: "innerheaderDIY",
  emits: ["clicked-rm-details"],
  components: {
    DemoDisclaimer
  },
  async mounted() {
    this.logo= this.$store.state.theme =='light' ? getDistributer()["distributorLogo"] : getDistributer()["distributorLogoDark"];
    if (getDiyResumeTokenFromRoute(this.$route) || getDiyJourneyIdFromRoute(this.$route) || hasDiyDeepLinkQuery(this.$route)) {
      await this.startSession();
    }
    if (!this.$store.state.configData && this.$store.state.token) {
        this.getConfigData();
      }
      this.darkModePresent = hasDarkMode();
  },
  data() {
    return {
      darkModePresent: false,
      logo:"",
      rmData: ""
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    isDarkMode() {
      return this.theme === 'light';
    }
  },
  methods: {
    toggleTheme(){
      this.$store.dispatch('toggleTheme');
    },
    getToken() {
      this.backendApi("getToken")
      .then((response) => {
        //console.log('save quote response: ', response);
          if(response == 'error') {
          self.apiError = true;
        } else if(response && response.data){
          //console.log('response token: ', response.data)

          let token = response.data.Data.Token;
          let USERID = response.data.Data.UserID;
          let key = this.rmData.Userid;

          this.getSPDetails(token, USERID, key);
        }

        
      })
      .catch((error) => {
        console.log('error msg block get token', error);
      });
    },
    getSPDetails(token, USERID, key) {
      let qData = {
        "data":{
          "UserID": USERID, 
          "Token": token,  
          "Key": key 
        }
      }
      this.backendApi("getSPDetails", qData)
      .then((response) => {
          if(response == 'error') {
          self.apiError = true;
        } else if(response && response.data) {
          if(response.data.Data[0] == undefined)
          {
            let tmpData = {
              "advisorCode": "149306",
              "channelType": "BR",
              "cusBankAccNo": "",
              "bankName": "BBBJ",
              "needRiskProfile": "",
              "csrLimCode": "99999 (Dummy code)",
              "cafosCode": "99999",
              "oppId": "",
              "fscCode": "01325137",
              "spCode": "109337",
              "bankBrnch": "SBIN",
              "source": "0BBJ",
              "lanNo": "",
              "selectedTab": "",
              "subChannel": ""
            };            
            sessionStorage.setItem("sp_details_data", JSON.stringify(tmpData));
          }
          else
          {
            console.log("defined SP");
            sessionStorage.setItem("sp_details_data", JSON.stringify(response.data.Data[0]));
          }          
        }
      })
      .catch((error) => {
        console.log('error msg block sp', error);
      });
    },
    getConfigData() {

      var headers = {
        Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
        "Content-Type": "application/json",
      };

      let reqData = [getDistributer()["distributerID"]];

      this.backendApi("getConfigData", reqData, headers, "get")
        .then((response) => {
          if (response == "error") {
            console.log("get config data error: block");
          } else if (response && response.data) {
            console.log("get config data success: response ", response.data.data.Jsondata[0].jsonDataUI);
            this.$store.commit('setConfigData', response.data.data.Jsondata[0].jsonDataUI)
            console.log("hdjfh", this.$store.state.configData)
          }
        })
        .catch((error) => {
          console.log("error msg block get config data", error);
        });

    },
    async startSession() {
      if (!ensureDiyLandAccess(this.$route, this.$store, this.$router)) {
        return;
      }
      const hadToken = Boolean(this.$store.state.token);
      try {
        await establishDiySessionFromRoute(this.$route, this.backendApi, this.$store);
        if (!hadToken && this.$store.state.token) {
          if (!this.$store.state.configData) {
            this.getConfigData();
          }
          // resumeToken OTP gate lives on the DIY page — avoid full reload after mint.
        }
      } catch (error) {
        console.log(error);
        console.log("Failed to start session");
        if (getDiyResumeTokenFromRoute(this.$route)) {
          redirectDiySessionFailure(this.$router, error?.message);
        } else {
          redirectUnauthorizedLegacyJourney(this.$router);
        }
      }
    },
    handleHomepage() {
      // Review & Pay (role 14) must stay on DIY — do not send to landing/quote `/`.
      let roleId = null;
      try {
        const rmData = sessionStorage.getItem("rm_data")
          ? JSON.parse(sessionStorage.getItem("rm_data"))
          : null;
        roleId = rmData?.RoleId != null ? String(rmData.RoleId) : null;
      } catch {
        /* ignore */
      }
      if (roleId === ROLE_ID.REVIEW_PAY) {
        return;
      }
      const distributer = getDistributer();
      if (distributer["distributerID"] === "KVB") {
        window.location.href = distributer.baseURL;
      } else {
        window.location.href = buildRouteUrl('');
      }
    },
  },
  watch: {
    theme(newTheme) {
      if (newTheme) {
        this.logo= newTheme =='dark' ? getDistributer()["distributorLogoDark"] : getDistributer()["distributorLogo"];
        document.body.className = newTheme;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/inner-header.scss";
</style>
